export default __webpack_public_path__ + "static/DisplayHDR-600-4f633a5cc0252c39de5c6f25fe83d721.png";